export default __webpack_public_path__ + "static/media/agua_logo.448907e0.png";